import { combineReducers } from 'redux';
// import assetsReducer from './components/pages/Assets/AssetsReducer';
import storeReducer from './components/pages/Store/storeReducer';
import vendorReducer from './components/pages/Vendor/vendorReducer';
import auditorReducer from './components/pages/Auditor/auditorReducer'
import wareHouseReducer from './components/pages/WareHouse/wareHouseReducer';
import assetsReducer from './components/pages/Assets/assetsReducer';
import assetsCategoryReducer from './components/pages/AssetCategory/assetsCategoryReducer';
import pmpReducer from './components/pages/PMP/pmpReducer';
import workOrderReducer from './components/pages/WorkOrder/workOrderReducer'
import QuotationReducer from './components/pages/Quotation/QuotationReducer'
import WasteManagementReducer from './components/pages/WastemanagementReducer'
import DeliveryEfficiencyReducer from './components/pages/DeliveryEfficiency/actions/DeliveryEfficiencyReducer'
import BudgetReducer from './components/pages/BudgetPlanner/Actions/BudgetReducer';
import tpvReducer from './components/pages/TPV/tpvReducer';
import maintenanceDashboardReducer from './components/pages/MaintenanceDashboard/maintenanceDashboardReducer'
import notificationReducer from './components/pages/Notifications/notificationReducer';

const rootReducer = combineReducers({
    store: storeReducer,
    wareHouse:wareHouseReducer,
    vendorList:vendorReducer,
    auditorList:auditorReducer,
    tpvList: tpvReducer,
    maintenanceDashboardList: maintenanceDashboardReducer,
    assetList:assetsReducer,
   assetsCategoryList:assetsCategoryReducer,
   pmpList: pmpReducer,
   WorkOrderStore : workOrderReducer,
   QuotationInfo : QuotationReducer,
   WasteManagement:WasteManagementReducer,
   DeliveryEfficiency:DeliveryEfficiencyReducer,
   BudgetList:BudgetReducer,
   notifications:notificationReducer,
})

export default rootReducer